import { useTranslation } from 'react-i18next';
import { Chip, Grid2 as Grid, Stack, Typography } from '@mui/material';
import RouteIcon from '@mui/icons-material/Route';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { OrderCard, OrderCardTextItem } from '../../../../components';
import { EcommerceLogo } from '../../../../../common/components';
import { WBoxIcon } from '@wareclouds/wareclouds-ui';
import { CrossdockingOrderCardExpand } from './CrossdockingOrderCardExpand';
import { ORDER_STATUSES } from '@wareclouds/frontend-common/b2c';

export default function CrossdockingOrderCard({ order, isIncomplete = false }) {
  const { t } = useTranslation(['description']);

  const unAvailable =
    order.id_status_order === ORDER_STATUSES.TO_RECEIVE_FROM_ECOMMERCE;

  const scannedPackagesCount = Object.keys(
    order?.order_packages?.metadata || {}
  ).length;

  const incompletePackageCount = isIncomplete
    ? `${scannedPackagesCount} de ${order.package_count}`
    : order.package_count;

  return (
    <OrderCard
      hasExpandedSection
      renderExpandSection={() => (
        <CrossdockingOrderCardExpand
          addressDetail={order.warecloud?.address_detail}
          ecommerceName={order.ecommerce?.ecommerce_name || order.id_ecommerce}
          lastUpdate={order.updatedAt}
          phoneNumber={order.warecloud?.phone}
          unAvailable={unAvailable}
        />
      )}
      ExpandIcon={
        <ExpandMoreIcon color={unAvailable ? 'secondary' : 'primary'} />
      }
    >
      <Grid container spacing={2}>
        <Grid container size={12}>
          <Grid size={12}>
            <Typography
              variant="body1"
              color={unAvailable ? 'secondary' : 'primary'}
              sx={{ fontWeight: '700' }}
            >
              {`#${order.order_code}`}
            </Typography>
          </Grid>

          <Grid size={12}>
            <Stack direction="row" spacing={1}>
              {order.package_count > 0 && (
                <Chip
                  label={incompletePackageCount}
                  size="small"
                  variant="outlined"
                  color={isIncomplete ? 'warning' : 'secondary'}
                  icon={<WBoxIcon sx={{ pt: 0.2 }} />}
                  sx={{
                    px: 1,
                    borderColor: isIncomplete ? 'warning.main' : '#888',
                    color: isIncomplete ? 'warning.main' : '#888',
                  }}
                />
              )}
              {(order?.id_route || order?.route?.id_route) && (
                <Chip
                  label={order?.id_route || order?.route?.id_route}
                  color={unAvailable ? 'secondary' : 'primary'}
                  size="small"
                  icon={<RouteIcon />}
                  sx={{ px: 1 }}
                />
              )}
            </Stack>
          </Grid>
        </Grid>

        <Grid container size={12} alignItems="center">
          <Grid size="auto">
            <EcommerceLogo
              src={order.ecommerce?.ecommerce_logo}
              sx={{ width: 60, objectFit: 'contain' }}
            />
          </Grid>
          <Grid size="grow">
            <OrderCardTextItem
              label={t('orders.warecloud.name', { ns: 'description' })}
              description={`${order.warecloud?.first_name} ${order.warecloud?.last_name}`}
              variant="body2"
              disabled={unAvailable}
            />
          </Grid>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <OrderCardTextItem
            label={t('orders.warecloud.address', { ns: 'description' })}
            description={order.warecloud?.address}
            disabled={unAvailable}
          />
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <OrderCardTextItem
            label={t('orders.warecloud.city', { ns: 'description' })}
            description={order.city?.city_name}
            disabled={unAvailable}
          />
        </Grid>
      </Grid>
    </OrderCard>
  );
}
